"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachConnectivityRequestHandler = exports.DISABLE_CONNECTIVITY_PROBE = void 0;
const utils_1 = require("@streamr/utils");
const uuid_1 = require("uuid");
const DhtRpc_1 = require("../../generated/packages/dht/protos/DhtRpc");
const ConnectionManager_1 = require("./ConnectionManager");
const connectivityChecker_1 = require("./connectivityChecker");
const WebsocketClientConnector_1 = require("./websocket/WebsocketClientConnector");
const version_1 = require("../helpers/version");
exports.DISABLE_CONNECTIVITY_PROBE = 0;
const logger = new utils_1.Logger(module);
const attachConnectivityRequestHandler = (connectionToListenTo, geoIpLocator) => {
    connectionToListenTo.on('data', async (data) => {
        logger.trace('server received data');
        try {
            const message = DhtRpc_1.Message.fromBinary(data);
            if (message.body.oneofKind === 'connectivityRequest') {
                logger.trace('ConnectivityRequest received: ' + JSON.stringify(DhtRpc_1.Message.toJson(message)));
                try {
                    await handleIncomingConnectivityRequest(connectionToListenTo, message.body.connectivityRequest, geoIpLocator);
                    logger.trace('handleIncomingConnectivityRequest ok');
                }
                catch (err1) {
                    logger.error('handleIncomingConnectivityRequest', { err: err1 });
                }
            }
        }
        catch (err2) {
            logger.trace('Could not parse message', { err: err2 });
        }
    });
};
exports.attachConnectivityRequestHandler = attachConnectivityRequestHandler;
const handleIncomingConnectivityRequest = async (connection, connectivityRequest, geoIpLocator) => {
    const host = connectivityRequest.host ?? connection.getRemoteIpAddress();
    const ipAddress = connection.getRemoteIpAddress();
    let connectivityResponse;
    if (connectivityRequest.port !== exports.DISABLE_CONNECTIVITY_PROBE) {
        connectivityResponse = await connectivityProbe(connectivityRequest, ipAddress, host);
    }
    else {
        logger.trace('ConnectivityRequest port is 0, replying without connectivityProbe');
        connectivityResponse = {
            host,
            natType: ConnectionManager_1.NatType.UNKNOWN,
            ipAddress: (0, utils_1.ipv4ToNumber)(ipAddress),
            protocolVersion: version_1.LOCAL_PROTOCOL_VERSION
        };
    }
    if (geoIpLocator !== undefined) {
        const location = geoIpLocator.lookup(ipAddress);
        if (location !== undefined) {
            connectivityResponse.latitude = location.latitude;
            connectivityResponse.longitude = location.longitude;
        }
    }
    const msg = {
        serviceId: connectivityChecker_1.CONNECTIVITY_CHECKER_SERVICE_ID,
        messageId: (0, uuid_1.v4)(),
        body: {
            oneofKind: 'connectivityResponse',
            connectivityResponse
        }
    };
    connection.send(DhtRpc_1.Message.toBinary(msg));
    logger.trace('ConnectivityResponse sent: ' + JSON.stringify(DhtRpc_1.Message.toJson(msg)));
};
const connectivityProbe = async (connectivityRequest, ipAddress, host) => {
    let outgoingConnection;
    let connectivityResponseMessage;
    try {
        const wsServerInfo = {
            host,
            port: connectivityRequest.port,
            tls: connectivityRequest.tls
        };
        const url = (0, WebsocketClientConnector_1.connectivityMethodToWebsocketUrl)(wsServerInfo, 'connectivityProbe');
        logger.trace(`Attempting Connectivity Check to ${url}`);
        outgoingConnection = await (0, connectivityChecker_1.connectAsync)({
            url,
            allowSelfSignedCertificate: connectivityRequest.allowSelfSignedCertificate
        });
        logger.trace('Connectivity test produced positive result, communicating reply to the requester ' + host + ':' + connectivityRequest.port);
        connectivityResponseMessage = {
            host,
            natType: ConnectionManager_1.NatType.OPEN_INTERNET,
            websocket: { host, port: connectivityRequest.port, tls: connectivityRequest.tls },
            ipAddress: (0, utils_1.ipv4ToNumber)(ipAddress),
            protocolVersion: version_1.LOCAL_PROTOCOL_VERSION
        };
    }
    catch (err) {
        logger.debug('error', { err });
        connectivityResponseMessage = {
            host,
            natType: ConnectionManager_1.NatType.UNKNOWN,
            ipAddress: (0, utils_1.ipv4ToNumber)(ipAddress),
            protocolVersion: version_1.LOCAL_PROTOCOL_VERSION
        };
    }
    if (outgoingConnection) {
        // TODO should we have some handling for this floating promise?
        outgoingConnection.close(false);
    }
    return connectivityResponseMessage;
};
//# sourceMappingURL=connectivityRequestHandler.js.map